import { Link } from 'react-router-dom';
import { siteInfo, categories } from '@/mocks/incidents';

export default function SiteFooter() {
  return (
    <footer className="w-full bg-secondary-950 text-background-200">
      <div className="mx-auto max-w-content px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5">
              <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-600 text-background-50">
                <i className="ri-radar-line"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50">{siteInfo.name}</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-secondary-300">{siteInfo.tagline}</p>
            <p className="mt-4 text-xs text-secondary-400">
              本站为资讯整理平台，所有内容基于公开信息归纳，不构成任何法律意见。
            </p>
          </div>

          <div>
            <h5 className="font-heading text-sm font-semibold text-background-50">主题分类</h5>
            <ul className="mt-4 space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.key}>
                  <Link
                    to={`/cases?category=${encodeURIComponent(cat.key)}`}
                    className="text-sm text-secondary-300 transition-colors hover:text-accent-400"
                  >
                    {cat.key}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h5 className="font-heading text-sm font-semibold text-background-50">站内导航</h5>
            <ul className="mt-4 space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-secondary-300 transition-colors hover:text-accent-400">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/cases" className="text-sm text-secondary-300 transition-colors hover:text-accent-400">
                  案件通报
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-secondary-300 transition-colors hover:text-accent-400">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/about#contact" className="text-sm text-secondary-300 transition-colors hover:text-accent-400">
                  线索提供
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h5 className="font-heading text-sm font-semibold text-background-50">联系与提示</h5>
            <ul className="mt-4 space-y-3 text-sm text-secondary-300">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line mt-0.5 text-accent-400"></i>
                <span className="break-all">{siteInfo.email}</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-error-warning-line mt-0.5 text-accent-400"></i>
                <span>遇紧急情况，请第一时间通过官方渠道求助。</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-4 border-t border-secondary-800 pt-6 text-xs text-secondary-400 sm:flex-row sm:items-center sm:justify-between">
          <p>© {new Date().getFullYear()} {siteInfo.name} · 内容整理与追踪，仅用于信息参考</p>
          <p className="flex flex-wrap items-center gap-x-4 gap-y-2">
            <span>建站时间 {siteInfo.since}</span>
            <span className="hidden sm:inline">·</span>
            <span>最近更新 {siteInfo.updatedAt}</span>
          </p>
        </div>
      </div>
    </footer>
  );
}